import React from 'react';
import { object } from 'prop-types';
// @material-ui/core
import withStyles from '@material-ui/core/styles/withStyles';
// react-icons
import { LuSparkles } from 'react-icons/lu';

// The new analytics app is served under /analytics/ on this same host.
const NEW_EXPERIENCE_URL = '/analytics/';

const styles = {
  pill: {
    position: 'fixed',
    right: '20px',
    bottom: '20px',
    zIndex: 30,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 16px',
    borderRadius: '9999px',
    border: '1px solid #7c3aed',
    backgroundColor: '#fff',
    boxShadow:
      '0 16px 40px rgba(15, 23, 41, 0.12), 0 4px 10px rgba(15, 23, 41, 0.06)',
    color: '#7c3aed',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '18px',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    transition: 'background-color 150ms ease, color 150ms ease',
    '&:hover': {
      color: '#6d28d9',
      backgroundColor: '#f5f3ff',
      textDecoration: 'none'
    },
    '&:focus': {
      outline: 'none'
    },
    '&:focus-visible': {
      boxShadow: '0 0 0 2px #fff, 0 0 0 4px #7c3aed'
    }
  },
  icon: {
    flexShrink: 0
  }
};

/**
 * @function
 * @description A floating way over to the new analytics app while both are in use
 */
const NewExperienceButton = ({ classes }) => (
  <a href={NEW_EXPERIENCE_URL} className={classes.pill}>
    <LuSparkles size={16} className={classes.icon} aria-hidden />
    Switch to a new experience
  </a>
);

NewExperienceButton.propTypes = {
  classes: object.isRequired
};

export default withStyles(styles)(NewExperienceButton);
